import { Stack } from "@mui/material";
import GoogleMapView from "./google-map-view";

const MapLayout = () => {
    return (
        <>
            <Stack>
                <GoogleMapView />
            </Stack>
        </>
    );
}

export default MapLayout;